import { useFeatureFlags } from "@/context/FeatureFlagsContext";

/**
 * Ritorna `true` se il feature flag `key` è abilitato per l'utente corrente.
 * NB: NON è un controllo di sicurezza — è puro rendering. Gli endpoint sensibili
 * devono avere il proprio RBAC lato backend.
 */
export default function useFeatureFlag(key) {
  const { flags } = useFeatureFlags();
  return flags?.[key] === true;
}
